import React from 'react'
import { BounceLoader } from 'react-spinners'
import './SweetSpinner.css'

export default class SweetSpinner extends React.Component {
    render() {
        return (
            <div className="spinner__container">
                <BounceLoader 
                    color={'#6C1137'}
                    loading={true}
                    size={90}
                />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SweetSpinner/SweetSpinner.jsx